import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container, Grid } from "@mui/material";
import { appdata } from "../models/appdata";
import { kirimWA } from "../models/kirimWa";

const GridProdukPart = () => {
  function handleOnClick(dt) {
    let txt = "Saya mau order\n";
    txt += `Nama Paket:${dt.nama}\n`;
    txt += `Harga: ${dt.harga}`;

    kirimWA(txt);
  }
  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        sx={{ fontWeight: "bold", textAlign: "center", p: 2, mt: 4 }}
      >
        Harga Sewa Mobil plus Driver
      </Typography>
      <Container>
        <Grid container spacing={2}>
          {appdata.produk.map((v, i) => (
            <MyItem key={i} data={v} onClick={() => handleOnClick(v)} />
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default GridProdukPart;

const MyItem = ({ data, onClick }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={{ maxWidth: 345 }}>
        <CardMedia
          component="img"
          height="200"
          image={data.image}
          alt={data.nama}
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            sx={{ height: 60 }}
          >
            {data.nama}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {data.subNama}
          </Typography>
          <Typography variant="h6" color="error">
            {data.harga}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: "pre-line", overflow: "hidden" }}
          >
            {data.keterangan}
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: "flex-end" }}>
          <Button onClick={onClick} variant="contained" size="small">
            ORDER
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};
